import { Component } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { SharedModule } from '../../shared/shared.module';

@Component({
    selector: 'app-spinner',
  standalone: true,
    imports: [SharedModule],
    templateUrl: './spinner.component.html',
    styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {
  value = 50;

  constructor(public loader: LoaderService) { }
}
